import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

export class RangeDatePicker {
    public fromDate: NgbDateStruct | null
    public toDate: NgbDateStruct | null

    constructor(){
        this.fromDate = null
        this.toDate = null
    }
}